import { FCWithChildren } from "~/types/react"

type TitledSectionProps = {
  id?: string
  title?: string
}

export const TitledSection: FCWithChildren<TitledSectionProps> = ({
  title,
  id,
  children,
}) => {
  return (
    <>
      {!!id && !!title && <h2 id={id}>{title}</h2>}
      {children}
    </>
  )
}
